"use client";

import { SwitchRoiForm as SharedSwitchRoiForm } from "@/components/compare/SwitchRoiForm.client";

export function SwitchRoiForm() {
  return (
    <SharedSwitchRoiForm
      competitorValue="staffbase"
      competitorLabel="Staffbase"
      formName="switch_roi_staffbase"
    />
  );
}
